<div class="modal fade" data-backdrop="static" id="passwordReset">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Modal body -->
            <div class="modal-body">
                    <form #fpass="ngForm" (ngSubmit)="setPass(fpass)" class="doctors-edit-main">
                <h2 class="text-center">Set Password</h2> 
                <div class="realtive">
                  <input class="form-control" name="Password" required #Password="ngModel" [type]="showEye ? 'password' : 'text'" placeholder="Enter Password..." [(ngModel)]="Pass" >
                  <span [class]="showEye ? 'fa fa-fw fa-eye' : 'fa fa-fw fa-eye-slash'" (click)="showEye=!showEye"></span>
                </div>
                  <div *ngIf="fpass.submitted && !Password.valid" class="alert alert-danger" >Password is required</div>
                  <div *ngIf="fpass.submitted && passwordValidation" class="alert alert-danger" >Password should be alphanumeric & should contain atleast one special character</div>
                  <input type="submit" value="Set Password" class="btn-style" id="resetpassbutton">
                  <div class="error" [ngStyle]="{ 'display': errorPassword ? 'block' : 'none', 'color':'red' }">There was
                        some error setting the password
                      </div>
                  </form>
            </div>
        </div>
    </div>
</div>

<input type="hidden" id="passwordResetbutton" data-toggle="modal" data-target="#passwordReset">